import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {useRouter} from 'vue-router';
import Icon from "@/components/Icons/Icon.vue";
import MainMenu from './MainMenu.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TopToolbar',
  setup(__props) {

const router = useRouter();

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, {
    app: "",
    color: "white",
    density: "compact",
    fixed: "",
    style: {"box-shadow":"0 2px 8px -8px gray"}
  }, {
    prepend: _withCtx(() => [
      _createVNode(MainMenu),
      _createVNode(_component_v_btn, { icon: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, {
            class: "primary-color",
            icon: "fa-search",
            size: "20"
          })
        ]),
        _: 1
      })
    ]),
    append: _withCtx(() => [
      _createVNode(_component_v_btn, {
        icon: "",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push({ name: 'notifications' })))
      }, {
        default: _withCtx(() => [
          _createVNode(Icon, {
            color: "primaryColor",
            icon: "bell-icon"
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_btn, {
        icon: "",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push({ name: 'client' })))
      }, {
        default: _withCtx(() => [
          _createVNode(Icon, {
            color: "primaryColor",
            icon: "person-icon"
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar_title, { class: "text-center" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            icon: "",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'home' })))
          }, {
            default: _withCtx(() => [
              _createVNode(Icon, {
                color: "primaryColor",
                icon: "home-icon"
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})